module.exports = __webpack_public_path__ + "static/media/torii-gate.d27805eb.svg";